import { schema } from 'normalizr';

const permissionSchema = new schema.Entity('permissions', {});

export default permissionSchema;
